import { ChangeDetectorRef, Component } from '@angular/core';
import { RoutingService, TranslationService, UserIdService } from '@spartacus/core';
import { combineLatest, take, Subscription } from 'rxjs';
import { SavedShoppingCartService } from 'src/app/services/feature/savedShoppingCart/saved-shopping-cart.service';
import { DeleteSavedCartDialogComponent } from '../delete-saved-cart-dialog/delete-saved-cart-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RestoreSavedCartDialogComponent } from '../restore-saved-cart-dialog/restore-saved-cart-dialog.component';
import moment from 'moment';
import { Store } from '@ngrx/store';
import { StateWithMultiCart } from '@spartacus/cart/base/core';
import { MultiCartFacade } from '@spartacus/cart/base/root';
@Component({
  selector: 'app-saved-shopping-cart',
  templateUrl: './saved-shopping-cart.component.html',
  styleUrls: ['./saved-shopping-cart.component.scss'],
  standalone: false
})
export class SavedShoppingCartComponent {
  savedCart: any
  pageItems: any;
  totalResults: any;
  sortName = false;
  sortNameDesc = false;
  sortNameType = '';

  sortId = false;
  sortIdDesc = false;
  sortIdType = '';

  sortDate = false;
  sortDateDesc = false;
  sortDateType = '';

  subscription = new Subscription();
  constructor(private savedShoppingCartService: SavedShoppingCartService,
    private cdr: ChangeDetectorRef, private translateService: TranslationService,
    private dialog: MatDialog, private router: Router,
    private userIdService: UserIdService,
    private multiCartService: MultiCartFacade,
    private routingService: RoutingService,
    protected store: Store<StateWithMultiCart>) {

  }
  ngOnInit() {
    this.getSavedCart();
  }
  getSavedCart(currentPage?, sort?) {
    this.subscription.add(this.savedShoppingCartService.getSavedCart(currentPage, sort).subscribe((data: any) => {
      this.savedCart = data;
      this.subscription.add(combineLatest([
        this.translateService.translate('common.text_account_savedCarts_page_totalResults'), this.translateService.translate('common.text_account_core_search_totalResultsCurrPage')
      ]).subscribe(([res1, res2]: any) => {
        this.totalResults = res1.replace('{0}', data.pagination.totalResults);

        if (data.pagination.totalPages == 1) {
          this.pageItems = res2.replace('{1}', data.pagination.totalResults).replace('{0}', '1 - ' + data.pagination.totalResults)
        } else if (data.pagination.totalPages > 1) {
          this.pageItems = res2.replace('{1}', data.pagination.totalResults).replace('{0}', (data.pagination.pageSize * data.pagination.currentPage) + 1 + '-' + data.pagination.pageSize * (data.pagination.currentPage + 1));
        }
        this.cdr.detectChanges();
      }));

    }));
  }

  restore(item) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'delete-saved-cart'
    const data = {
      name: item.name,
      id: item.code,
      positions: item.entries.length
    }
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(RestoreSavedCartDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      cartId => {

        if (!cartId) {
          return;
        }
        this.userIdService.takeUserId().pipe(take(1)).subscribe(userId => {
          this.multiCartService.loadCart({
            userId,
            cartId,
            extraData: { active: true },
          });
        });

        this.routingService.go({ cxRoute: 'cart' });

      })

  }

  changePageCustom(e) {
    this.getSavedCart(e);
  }

  sort(type) {
    if (type === 'name') {
      this.sortName = !this.sortName;
      const sort = this.sortName ? 'byName' : 'byNameAsc'
      this.sortIdType = '';
      this.sortDateType = '';
      this.sortNameType = this.sortName ? 'desc' : 'asc';
      this.getSavedCart(0, sort);

    } else if (type === 'id') {
      this.sortId = !this.sortId;
      const sort = this.sortId ? 'byCode' : 'byCodeAsc';
      this.sortIdType = this.sortId ? 'desc' : 'asc';
      this.sortDateType = '';
      this.sortNameType = '';
      this.getSavedCart(0, sort);

    } else if (type === 'date') {
      this.sortDate = !this.sortDate;
      const sort = this.sortDate ? 'byDateSaved' : 'byDateSavedAsc';
      this.sortIdType = '';
      this.sortDateType = this.sortDate ? 'desc' : 'asc';
      this.sortNameType = '';
      this.getSavedCart(0, sort);
    }
  }

  redirectCart(item) {
    this.router.navigate(["saved-carts", item.code]);
  }
  formatDate(dateString: string, format?: string): string {
    const date = new Date(dateString);
    return moment(date).format(format.toUpperCase());


  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  deleteSavedCart(item) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'delete-saved-cart'
    const data = {
      name: item.name,
      id: item.code,
      positions: item.entries.length
    }
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(DeleteSavedCartDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data.message === 'SUCCESS') {
          this.getSavedCart();
        }
      })
  }
}
